import PropTypes from 'prop-types'
import React, { Component } from 'react';
import {
    Button,
    Container,
    Menu,
    Segment,
    Visibility,
} from 'semantic-ui-react';
import { Link } from 'react-scroll';
import { Media, openInNewTab } from '../util/util';
import HomepageHeading from './HomepageHeading';

class DesktopContainer extends Component {
    state = {activeItem : 'initial'}

    handleItemClick = (name) => {
        console.log(name);
        this.setState({ activeItem: name });
    }
    hideFixedMenu = () => this.setState({ fixed: false })
    showFixedMenu = () => this.setState({ fixed: true })

    render() {
        const { children } = this.props
        const { fixed, activeItem } = this.state
        return (
            <Media greaterThan='mobile'>
                <Visibility
                    once={false}
                    onBottomPassed={this.showFixedMenu}
                    onBottomPassedReverse={this.hideFixedMenu}
                >
                    <Segment
                        inverted
                        textAlign='center'
                        style={{ minHeight: 700, padding: '1em 0em' }}
                        vertical
                    >
                        <Menu
                            fixed={fixed ? 'top' : null}
                            inverted={!fixed}
                            pointing={!fixed}
                            secondary={!fixed}
                            size='large'
                        >
                            <Container>
                                <Menu.Item
                                    name='home_menu'
                                    active={activeItem === "home_menu"}
                                    as={ Link }
                                    to="top"
                                    smooth={true}
                                    duration={1000}
                                    onClick={() => this.handleItemClick("home_menu")}
                                >Home
                                </Menu.Item>
                                <Menu.Item
                                    name='posts_menu'
                                    active={activeItem === "posts_menu"}
                                    as = { Link }
                                    to="posts"
                                    smooth={true}
                                    duration={1000}
                                    onClick={() => this.handleItemClick("posts_menu")}
                                >Posts
                                </Menu.Item>
                                <Menu.Item
                                    name='products_menu'
                                    active={activeItem === "products_menu"}
                                    as = {Link}
                                    to="products"
                                    smooth={true}
                                    duration={1000}
                                    onClick={() => this.handleItemClick("products_menu")}
                                >Products
                                </Menu.Item>
                                <Menu.Item
                                    name='contact_menu'
                                    active={activeItem === "contact_menu"}
                                    as={ Link }
                                    to="contact"
                                    smooth={true}
                                    duration={1000}
                                    onClick={() => this.handleItemClick("contact_menu")}
                                >Contact Us
                                </Menu.Item>
                                <Menu.Item position='right'>
                                    <button onClick={() => openInNewTab("https://www.facebook.com/trinutspampanga")} class="ui icon blue button">
                                        <i class="facebook icon"></i>
                                    </button>
                                    &nbsp;
                                    &nbsp;
                                    <button onClick={() => openInNewTab("https://g.page/trinuts")} class="ui icon red button">
                                        <i class="google icon"></i>
                                    </button>
                                </Menu.Item>
                            </Container>
                        </Menu>
                        <div id="top"></div>
                        <HomepageHeading />
                    </Segment>
                </Visibility>

                {children}
            </Media>
        )
    }
}

DesktopContainer.propTypes = {
    children: PropTypes.node,
}

export default DesktopContainer;